<div class="flex flex-col justify-center p-6">
    <div class="flex flex-col sm:flex-row flex-wrap w-full">
        <div class="flex">
            <a class="mx-1 underline" target="_blank" rel="noopener noreferrer"
                href="https://www.{{triconDomain}}.com/licenses/">Licenses</a>
            <div class="mx-1">|</div>
            <a class="mx-1 underline" target="_blank" rel="noopener noreferrer"
                href="https://www.{{triconDomain}}.com/privacy-policy/">Privacy Policy</a>
        </div>
        <div class="flex">
            <a class="mx-1 underline" target="_blank" rel="noopener noreferrer"
                href="https://www.{{triconDomain}}.com/terms-of-use/">Terms of Use</a>
            <div class="mx-1">|</div>
            <a class="mx-1 underline" target="_blank" rel="noopener noreferrer"
                href="https://www.{{triconDomain}}.com/files/Terms-of-Agreement-and-Qualifications.pdf">Terms of
                Agreement</a>
        </div>
    </div>
    <div class="my-3">&copy; {{year}} Tricon. All rights reserved.</div>
    <div><i>If you are using a screen reader and having difficulty, please call 844 874 2661</i></div>
    <div><img class="h-8"
            style="filter: invert(35%) sepia(13%) saturate(125%) hue-rotate(145deg) brightness(92%) contrast(91%)"
            src="../../assets/images/equal-housing-opportunity.png" alt="Tricon" /></div>
</div>
